import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import User from './User.vue'
import Home from './Home.vue'
import Contact from './Contact.vue'


Vue.config.productionTip = true

Vue.use(VueRouter)

if (process.env.NODE_ENV == "development"){
  Vue.prototype.$hostname = 'http://api.mintrangselskatt.se.dev'
}else{
  Vue.prototype.$hostname = 'https://api.mintrangselskatt.se'
}

import VuejsDialog from 'vuejs-dialog';

import 'vuejs-dialog/dist/vuejs-dialog.min.css';



Vue.use(VuejsDialog);



const routes = [
  { path: '/contact', component: Contact },
  { path: '/contact/:token', component: Contact },
  { path: '/user/:token', component: User },
  { path: '/:token', component: Home },
  { path: '/', component: Home }
]

const router = new VueRouter({
  routes // short for `routes: routes`
})


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
